import { render, staticRenderFns } from "./HistoryDownloader.vue?vue&type=template&id=bc1571b2&"
import script from "./HistoryDownloader.vue?vue&type=script&lang=js&"
export * from "./HistoryDownloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports